import React from 'react'
import PropTypes from 'prop-types'

import Asterisk from '../Asterisk'
import Checkbox from '../Checkbox'
import FieldError from '../FieldError'

const CheckboxInput = ({
  required,
  label,
  name,
  values,
  errors,
  touched,
  className = '',
  inputClassName = '',
  disabled = false,
  onChange = () => { },
  onBlur = () => { },
  isMixed = false,
  popover = null,
  noError = false,
  dataPrivate = true
}) => (
  <div>
    <div className={`form-group form-check col mb-0 ${disabled ? '' : (errors[name] && touched[name]) ? 'has-danger' : ''} ${className}`}>
      <Checkbox
        name={name}
        className={inputClassName}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        checked={values[name]}
        isMixed={isMixed}
        dataPrivate={dataPrivate}
      />
      <label htmlFor={name} className={disabled ? '' : 'pointer'}>{label}{required && <Asterisk />}</label>
      {popover}
    </div>
    {!noError && <FieldError error={errors[name]} touched={touched[name]} disabled={disabled} />}
  </div>
)

CheckboxInput.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  isMixed: PropTypes.bool,
  popover: PropTypes.any,
  noError: PropTypes.bool,
  dataPrivate: PropTypes.bool
}

export default CheckboxInput
